export default __webpack_public_path__ + "static/media/R_wdt_c_cap_0.6d484180.mp3";